import { toolsAPI } from '../../api'

const DEFAULT_STATE = {
  currentTool: {
    data: null,
    isFetching: true,
    hasError: false
  },
  allTools: {
    data: null,
    isFetching: true
  },
  reviews: {
    data: [],
    isFetching: false
  }
}

// Actions
export const types = {
  SET_CURRENT_TOOL: 'gulftree/tools/SET_CURRENT_TOOL',
  SET_CURRENT_TOOL_IS_FETCHING: 'gulftree/tools/SET_CURRENT_TOOL_IS_FETCHING',
  SET_CURRENT_TOOL_HAS_ERROR: 'gulftree/tools/SET_CURRENT_TOOL_HAS_ERROR',
  SET_ALL_TOOLS: 'gulftree/tools/SET_ALL_TOOLS',
  SET_ALL_TOOLS_IS_FETCHING: 'gulftree/tools/SET_ALL_TOOLS_IS_FETCHING',
  SET_REVIEWS: 'gulftree/tools/SET_REVIEWS',
  SET_REVIEWS_IS_FETCHING: 'gulftree/tools/SET_REVIEWS_IS_FETCHING',
}

// Reducer
export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {

    case types.SET_CURRENT_TOOL:
      return {
        ...state,
        currentTool: {
          ...state.currentTool,
          data: action.payload
        }
      }

    case types.SET_CURRENT_TOOL_IS_FETCHING:
      return {
        ...state,
        currentTool: {
          ...state.currentTool,
          isFetching: action.payload
        }
      }

    case types.SET_CURRENT_TOOL_HAS_ERROR:
      return {
        ...state,
        currentTool: {
          ...state.currentTool,
          hasError: action.payload
        }
      }

    case types.SET_ALL_TOOLS:
      return {
        ...state,
        allTools: {
          ...state.allTools,
          data: action.payload
        }
      }

    case types.SET_ALL_TOOLS_IS_FETCHING:
      return {
        ...state,
        allTools: {
          ...state.allTools,
          isFetching: action.payload
        }
      }

    case types.SET_REVIEWS:
      return {
        ...state,
        reviews: {
          ...state.reviews,
          data: action.payload
        }
      }

    case types.SET_REVIEWS_IS_FETCHING:
      return {
        ...state,
        reviews: {
          ...state.reviews,
          isFetching: action.payload
        }
      }

    default:
      return state;
  }
}

// Action Creators
export function fetchCurrentTool(slug) {
  return (dispatch) => {
    dispatch({ type: types.SET_CURRENT_TOOL_IS_FETCHING, payload: true })

    toolsAPI.fetchToolBySlug(slug)
      .then(res => {
        dispatch({ type: types.SET_CURRENT_TOOL, payload: res })
        dispatch({ type: types.SET_CURRENT_TOOL_HAS_ERROR, payload: false })
        dispatch({ type: types.SET_CURRENT_TOOL_IS_FETCHING, payload: false })
      })
      .catch(err => {
        dispatch({ type: types.SET_CURRENT_TOOL, payload: null })
        dispatch({ type: types.SET_CURRENT_TOOL_HAS_ERROR, payload: true })
        dispatch({ type: types.SET_CURRENT_TOOL_IS_FETCHING, payload: false })
      })
  }
}

export function fetchAllTools() {
  return (dispatch) => {
    dispatch({ type: types.SET_ALL_TOOLS_IS_FETCHING, payload: true })

    toolsAPI.fetchAllTools().then(res => {
      dispatch({ type: types.SET_ALL_TOOLS, payload: res })
      dispatch({ type: types.SET_ALL_TOOLS_IS_FETCHING, payload: false })
    })
  }
}

export function fetchAllReviews(slug) {
  return (dispatch) => {
    dispatch({ type: types.SET_REVIEWS_IS_FETCHING, payload: true })

    toolsAPI.fetchToolReviewsBySlug(slug).then(res => {
      dispatch({ type: types.SET_REVIEWS, payload: res })
      dispatch({ type: types.SET_REVIEWS_IS_FETCHING, payload: false })
    })
  }
}

export function createReview(toolId, reviewData) {
  return (dispatch) => {
    return toolsAPI.createToolReview(toolId, reviewData).then(res => {
      dispatch({ type: types.SET_REVIEWS, payload: res })
    })
  }
}
